// FILE: src/components/common/DataSourcePill/DataSourcePill.jsx
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRotateRight,
  faCircleCheck,
  faCircleHalfStroke,
} from "@fortawesome/free-solid-svg-icons";
import styles from "./DataSourcePill.module.css";

export default function DataSourcePill({
  fromCache = null,
  loading = false,
  onRefresh,
  showRefresh = true,
  className = "",
}) {
  if (fromCache === null) return null;

  const isCache = !!fromCache;
  const chipClass = `${styles.sourceChip} ${isCache ? styles.cache : styles.live}`;
  const spinClass = loading ? styles.spin : "";

  return (
    <div className={`d-inline-flex align-items-center gap-2 ${className}`}>
      <span
        className={chipClass}
        title={isCache ? "Showing data from local cache" : "Showing data from Live DB"}
      >
        <FontAwesomeIcon
          icon={isCache ? faCircleHalfStroke : faCircleCheck}
          className={styles.chipIcon}
        />
        {isCache ? "Local cache" : "Live DB"}
      </span>

      {showRefresh && typeof onRefresh === "function" && (
        <button
          type="button"
          className={`btn btn-sm btn-outline ${styles.refreshBtn}`}
          onClick={onRefresh}
          disabled={loading}
          aria-label="Refresh from Live DB"
        >
          <FontAwesomeIcon
            icon={faRotateRight}
            className={`${styles.btnIcon} ${spinClass}`}
          />
        </button>
      )}
    </div>
  );
}
